<template>
    <div>
        <el-card class="dashboard-card"
                 v-loading="isLoading">
            <h3 class="cart-title">
                <i class="el-icon-search"></i> 작품 검색
                <el-input type="text"
                          class="art-search-input"
                          placeholder="작품ID 를 적어주세요."
                          v-model="artId"
                          maxlength="36"
                          show-word-limit
                          @keydown.enter.native="getArt"/>
                <el-button type="primary"
                           circle
                           @click.prevent="getArt"><i class="el-icon-search"></i>
                </el-button>
            </h3>
        </el-card>

        <el-card v-for="art in artList"
                 :key="art.artId"
                 class="art-card"
                 :body-style="{ padding: '0px' }">
            <img :src="$S3_PREFIX + art.mainImage.publicPath"
                 class="main-image"
                 @click.prevent="openArtDetail(art)"/>
            <div class="item-body">
                <p class="item-title">{{art.artId}}</p>
                <p class="item-date">{{art.createdAt | dateTime}}</p>
            </div>
            <i class="el-icon-close delete-button"
               @click.prevent="closeArt(art.artId)"></i>
        </el-card>

        <Cafe24ArtDetailModal v-if="selectedArt"
                              :art="selectedArt"
                              @close="closeArtDetail"/>
    </div>
</template>

<script>
    import {RepositoryFactory} from '@/repositories/RepositoryFactory';
    import Cafe24ArtDetailModal from '@/components/cafe24/Cafe24ArtDetailModal';

    const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

    export default {
        name: 'Cafe24ArtList',
        components: {Cafe24ArtDetailModal},
        data() {
            return {
                isLoading: false,
                artId: '',
                artList: [],

                selectedArt: null,
            };
        },
        computed: {
            mall() {
                return this.$store.state.cafe24.mall;
            },
            authToken() {
                return this.$store.state.auth.authToken;
            },
        },
        methods: {
            async getArt() {
                const oldArt = this.artList.find(art => art.artId === this.artId);
                if (oldArt) {
                    this.$message.success('이미 목록에 있는 작품입니다.');
                    this.openArtDetail(oldArt);
                    return;
                }

                try {
                    this.isLoading = true;
                    const {data: art} = await PrintingDiyRepository.getPartnerArt(this.mall.mallId, this.artId, this.authToken);
                    this.artList.push(art);
                    this.openArtDetail(art);
                } catch (e) {
                    this.$message.error(e.message);
                } finally {
                    this.artId = '';
                    this.isLoading = false;
                }
            },

            openArtDetail(art) {
                this.artId = '';
                this.selectedArt = art;
            },

            closeArtDetail() {
                this.selectedArt = null;
            },

            closeArt(artId) {
                this.artList = this.artList.filter(art => art.artId !== artId);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .art-search-input {
        display: inline-block;
        width: 360px;
        margin: 0 10px;
    }

    .art-card {
        display: inline-block;
        position: relative;
        margin-right: 20px;
        width: 320px;

        .main-image {
            width: 100%;
            display: block;
            cursor: pointer;
        }

        .item-body {
            padding: 14px;

            .item-title {
                font-size: 14px;
            }

            .item-date {
                margin-top: 10px;
                font-size: 12px;
                color: #888;
            }
        }

        .delete-button {
            display: block;
            position: absolute;
            font-size: 30px;
            color: #f56c6c;
            top: 10px;
            right: 10px;
            cursor: pointer;

            &:hover {
                color: red;
            }
        }
    }
</style>